// components/ButtonTh.js
import React from 'react';
import { Link } from 'react-router-dom';

const ButtonTh = ({ to, children }) => {
  return (
    <button
      className="bg-[#ED213A] hover:bg-[#93291E] active:bg-[#93291E] text-2xl text-slate-50 font-bold px-4 rounded justify-center"
    >
      {children}
    </button>
  );
};



export default ButtonTh;